import React, { useContext, useRef, useMemo } from 'react';
import { Context } from '@front10/helpers/dist/Context';
import { ThemeProvider } from '@front10/base-elements';
import { EmotionCache } from '../../containers/_commons/emotionCache';

/**
 * Atoms
 */
import { Listbox } from '../../lab/Listbox';
import Box from '../../elements/Box';
import Icon from '../../elements/Icon';
import Text from '../../elements/Text';
/**
 * Hooks
 */

const Sorting = (props, ref) => {
  const {
    value,
    labelKey = 'cmp-location-selector-label-flight-type',
    options = [
      'price_specification_low_to_high',
      'price_specification_high_to_low',
      'most_popular',
      'star_rating_high_to_low',
      'duration_high_to_low'
    ],
    sortingOptionsLabelsMap = {
      price_specification_low_to_high: 'fare_price_low_to_high_sorting_label',
      price_specification_high_to_low: 'fare_price_high_to_low_sorting_label',
      most_popular: 'fare_most_popular_sorting_label',
      star_rating_high_to_low: 'fare_star_rating_label',
      duration_high_to_low: 'fare_duration_label'
    },
    optionSettings,
    blankOptionSettings,
    checkIconSettings,
    labelSettings,
    disabled,
    onChange,
    listBoxSettings,
    showDescriptionLabel = false,
    loading = false
  } = props;

  const {
    translate,
    direction,
    theme: { designTokens }
  } = useContext(Context);

  const title = translate('cmp-flight-type-title', 'Flight Type');

  const sortingOptions = useMemo(() => {
    return (Array.isArray(options) ? options : []).map((option, index) => ({
      label: translate(sortingOptionsLabelsMap[option]),
      text: translate(sortingOptionsLabelsMap[option]),
      value: option
    }));
  }, [options, sortingOptionsLabelsMap, translate]);

  const listboxRef = useRef(null);

  React.useImperativeHandle(
    ref,
    () => ({
      focusToggleElement: () => {
        listboxRef.current.focusToggleElement();
      }
    }),
    []
  );

  const renderItem = (item, itemsProps, itemSelected, itemHighlighted) => {
    return (
      <Box
        role="listitem"
        {...itemsProps} //INFO: downshift props
        dataItemSelected={itemSelected}
        dataItemHighlighted={itemHighlighted}
        ariaCurrent={itemSelected}
        {...optionSettings}
      >
        {itemSelected && <Icon icon="check" {...checkIconSettings} />}
        {!itemSelected && <Box {...blankOptionSettings} />}
        <Text {...labelSettings}>{item.label}</Text>
      </Box>
    );
  };

  return (
    <EmotionCache direction={direction}>
      <ThemeProvider theme={designTokens}>
        <Listbox
          ref={listboxRef}
          label={translate(labelKey, 'Sorting')}
          placeholder={title}
          options={sortingOptions}
          defaultValue={value}
          forcePlaceholder={disabled}
          disabled={disabled}
          focusWhenIsShow={false}
          onChange={(value) => {
            onChange({
              target: { value, options: sortingOptions, selectedIndex: options.indexOf(value) }
            });
            listboxRef.current.focusToggleElement();
          }}
          {...listBoxSettings}
          prefixSelectedItem={
            showDescriptionLabel
              ? translate('cmp-sorting-filter-prefix-selected-item', 'Sort:')
              : null
          }
          renderItem={renderItem}
          loading={loading}
        />
      </ThemeProvider>
    </EmotionCache>
  );
};

export default React.forwardRef(Sorting);
